import React from 'react';
import { connect } from 'react-redux';
import objectAssign from 'object-assign';

import { clone } from '../reducers/helper';
import { hasPermissionOrg } from 'businessLogic/checkExistOrVerifyPermissions';
import { updateFetchingOrg } from 'actions/organisation';
import OrgUnitManageUsersContent from '../components/pages/org-unit/manage-users/content';
import NotFoundPage from './NotFoundPage.js';

@connect(mapStateToProps)
export default class OrganisationalUnitManageUsersPage extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount() {
    //Set getting org = {} to force fetching org info & permission first
    this.props.dispatch(updateFetchingOrg({}));
  }

  render() {
    // permissions check
    if (
      this.props.userId > 0 &&
      (this.props.redirectToPageNotFound || !this.props.hasOrganisations || this.props.canAccess == false)
    )
      return <NotFoundPage dispatch={this.props.dispatch} />;

    return (
      <OrgUnitManageUsersContent
        id={parseInt(this.props.match.params.id)}
        organisationalUnit={this.props.organisationalUnit}
        searchTerm={this.props.searchTerm}
        dispatch={this.props.dispatch}
        fetchingUserICanManage={this.props.fetchingUserICanManage}
        timezone={this.props.timezone}
        usersIcanManage={this.props.usersIcanManage}
        showManageRolesForOrgUsersModal={this.props.showManageRolesForOrgUsersModal}
        availableRoles={this.props.availableRoles}
        showOrganisationalUnitAddUsersModal={this.props.showOrganisationalUnitAddUsersModal}
        selectedOrgUsersEmail={this.props.selectedOrgUsersEmail}
      />
    );
  }
}

function mapStateToProps(state, props) {
  let selectedOrganisationalUnit = state.organisationsReducer.cleanOrganisationalUnit;
  let usersIcanManageInThisOrganisationalUnit = [];
  let availableRoles = [];

  if (!!state.organisationsReducer.selectedOrgUnitId) {
    const selectedOrgUnitId = state.organisationsReducer.selectedOrgUnitId;
    selectedOrganisationalUnit = state.organisationsReducer.organisations.find(
      (org) => org.networkId === selectedOrgUnitId
    );

    if (!!selectedOrganisationalUnit) {
      availableRoles = selectedOrganisationalUnit.availableRoles;
    }

    if (state.usersReducer.usersIcanManage && state.usersReducer.usersIcanManage.length > 0) {
      usersIcanManageInThisOrganisationalUnit = state.usersReducer.usersIcanManage;
    }
  }
  let networkId = props.match.params.id;
  // Necessary code to check permission
  let fetchingOrgUnit = state.organisationsReducer.fetchingOrganisation;
  let canAccess = fetchingOrgUnit === false ? hasPermissionOrg(state, networkId, 'MANAGE_MEMBER_ROLES') : true;

  const organisationalUnit = objectAssign(
    {},
    state.organisationsReducer.cleanOrganisationalUnit,
    selectedOrganisationalUnit
  );

  return {
    redirectToPageNotFound: state.sharedReducer.redirectToPageNotFound,
    usersIcanManage: usersIcanManageInThisOrganisationalUnit,
    organisationalUnit: organisationalUnit,
    showOrganisationalUnitAddUsersModal: state.modalReducer.showOrganisationalUnitAddUsersModal,
    fetchingUserICanManage: state.organisationsReducer.fetchingUserICanManage,
    searchTerm: state.organisationsReducer.currentOrganisationalUnitMemberFilter || '',
    hasOrganisations: state.usersReducer.userProfile.hasOrganisations,
    availableRoles: availableRoles,
    userId: state.usersReducer.userProfile.id,
    timezone: state.usersReducer.userProfile.timezoneOffsetNow,
    showManageRolesForOrgUsersModal: state.modalReducer.showManageRolesForOrgUsersModal,
    selectedOrgUsersEmail: state.organisationsReducer.selectedOrgUsersEmail,
    canAccess,
  };
}
